// import { ID_PRODUCTO_CREDITO_ACTIVACASH } from '../../utilidades/utilidades'
import {
  agregarFolioDigitalStorage,
  agregarMedioContactoStorage,
} from '@/servicios/sessionStorage.js'

const state = {
  credito: {
    tipoCredito: null,
    monto: {
      title: 'MONTO',
      val: 0,
      mask: 'money',
      max: 0,
    },
    frecuenciaSeleccionada: {
      title: 'FRECUENCIA',
      val: 'Mensual',
      mask: '',
      id_esquema: '',
      id_periodicidad: '',
    },
    plazo: {
      title: 'PLAZO',
      val: '',
      mask: '',
      name: '',
    },
    fechaPago: {
      title: 'FECHA DE PAGO',
      val: '15 y 30',
      mask: 'de cada mes',
    },
    tasa: {
      title: 'TASA',
      val: '4',
      mask: '',
    },
    montoPago: {
      title: 'MONTO DE PAGO',
      val: 0,
      mask: 'Pago mensual de $',
      cat: '',
    },
  },
  frecuencia: {
    label: 'Elige cada cuándo quieres pagar:',
    valores: ['Mensual'],
  },
  catFreq: [],
  plazos: [],
  fullPlazos: [],
  confirmado: false,
  editable: true,
  finalizado: false,
  otpInicio: '',
  otpFirma: '',
  esOtpFirmaValido: false,
  folioDigital: '',
  total_liquidacion: 0,
  sonTerminosAceptados: false,
  sonTerminosBuroAceptados: false,
  sonTerminosBuroConfirmados: false,
  aceptaFirmar: false,
  idConvenio: 0,
  catalogoPeriodicidad: [],
  idSolicitud: null,
  aplicaDevolucion: null,
  aplicaDevolucionMonto: null,
  aplicaDevolucionDomicilio: null,
  observacionesDevolucion: '',
  fechaVigencia: '',
  medioDeContacto: 0,
  ase: null,
  location: { lat: '', lon: '' },
  estatus: { estatus: '', substatus: '', banca_activa: 0 },
  num_usuario_apoyo: 0,
  rangoMontosPlazos: [],
}

const mutations = {
  setConfirmacion(state, payload) {
    state.confirmado = payload
  },
  setEditable(state, payload) {
    state.editable = payload
  },
  setFinalizado(state, payload) {
    state.finalizado = payload
  },
  setCredito(state, payload) {
    state.credito = payload
  },
  setPlazos(state) {
    state.plazos =
      state.fullPlazos[
        state.catFreq.find(
          (freq) => freq.val == state.credito.frecuenciaSeleccionada.val
        ).id
      ]
  },
  setPlazo(state, payload) {
    state.credito.plazo = payload
  },
  setOtp(state, payload) {
    state.otpInicio = payload.otpInicio
  },
  setOtpFirma(state, payload) {
    state.otpFirma = payload.otpFirma
  },
  setEntrada(state, payload) {
    const cred = {
      tipoCredito: payload.Id_subproducto,
      tipoProcesoCredito: payload.id_proceso_credito_digital,
      monto: {
        title: 'MONTO',
        val: payload.Monto_Preautorizado,
        mask: 'money',
        max:
          payload.Id_subproducto == 246 && payload.Monto_Preautorizado > 60000
            ? payload.Monto_Preautorizado > 100000
              ? 500000
              : 200000
            : payload.Id_subproducto == 245
            ? 80000
            : payload.Monto_Preautorizado, //266 SOCIO PUNTUAL
      },
      frecuenciaSeleccionada: {
        title: 'FRECUENCIA',
        val: 'Mensual',
        mask: '',
        id_esquema: '',
        id_periodicidad: '',
      },
      plazo: {
        title: 'PLAZO',
        val: payload.Plazo,
        mask: '',
        name: '',
      },
      fechaPago: {
        title: 'FECHA DE PAGO',
        val: '15 y 30',
        mask: 'de cada mes',
      },
      tasa: {
        title: 'TASA',
        val: payload.Tasa,
        mask: '',
      },
      montoPago: {
        title: 'MONTO DE PAGO',
        val: 0,
        mask: 'Pago mensual de $',
        cat: '',
      },
      otpFirma: '',
    }
    state.credito = cred
  },
  setPlazosDisponibles(state, payload) {
    let conversionPlazos = []
    let conversionFrecuencias = []
    const getMask = function (freq) {
      switch (freq) {
        case 'Mensual':
          return 'meses'
        case 'Quincenal':
          return 'quincenas'
        case 'Semanal':
          return 'semanas'
        default:
          break
      }
    }
    payload.Periodicidad.forEach((frecuencia, index) => {
      conversionFrecuencias.push(frecuencia.frecuencia)
      let plazosPorFrecuencia = []
      frecuencia.plazos.forEach((plazo) => {
        plazosPorFrecuencia.push({
          name: plazo.plazo + ' ' + getMask(frecuencia.frecuencia),
          val: plazo.plazo,
          title: 'PLAZO',
          mask: getMask(frecuencia.frecuencia),
        })
      })
      conversionPlazos.push(plazosPorFrecuencia)
      state.catFreq.push({
        id: index,
        val: frecuencia.frecuencia,
      })
    })
    state.fullPlazos = conversionPlazos
    state.frecuencia.valores = conversionFrecuencias
    state.credito.frecuenciaSeleccionada.val = conversionFrecuencias[0]
  },
  setRangoMontosPlazos(state, payload) {
    state.rangoMontosPlazos = payload.Rango_Montos_Plazos
  },
  setMontoPago(state, payload) {
    state.credito.montoPago.val = payload[0].total
    state.credito.montoPago.cat = payload[0].cat
  },
  setFolioDigital(state, payload) {
    state.folioDigital = payload
    agregarFolioDigitalStorage(payload)
  },
  setTotalLiquidacion(state, payload) {
    state.total_liquidacion = payload
  },
  setEsOtpFirmaValido(state, payload) {
    state.esOtpFirmaValido = payload
  },
  setSonTerminosAceptados(state, payload) {
    state.sonTerminosAceptados = payload
  },
  setAceptaFirmar(state, payload) {
    state.aceptaFirmar = payload
  },
  setSonTerminosBuroAceptados(state, payload) {
    state.sonTerminosBuroAceptados = payload
  },
  setSonTerminosBuroConfirmados(state, payload) {
    state.sonTerminosBuroConfirmados = payload
  },
  setConvenio(state, payload) {
    state.idConvenio = payload
  },
  setCatalogoPeriodicidad(state, payload) {
    // console.log(payload, 'hey hye')
    state.catalogoPeriodicidad = payload
    state.credito.frecuenciaSeleccionada.id_esquema = payload[0].id_esquema
    state.credito.frecuenciaSeleccionada.id_periodicidad =
      payload[0].id_periodicidad
  },
  setDatosPeriodicidadFrecuenciaSeleccionada(state, payload) {
    state.credito.frecuenciaSeleccionada.id_esquema = payload.id_esquema
    state.credito.frecuenciaSeleccionada.id_periodicidad =
      payload.id_periodicidad
  },
  setIdSolicitud(state, payload) {
    state.idSolicitud = payload
  },
  setAplicaDevolucion(state, payload) {
    state.aplicaDevolucion = payload
  },
  setAplicaDevolucionMonto(state, payload) {
    state.aplicaDevolucionMonto = payload
  },
  setAplicaDevolucionDomicilio(state, payload) {
    state.aplicaDevolucionDomicilio = payload
  },
  setObservacionesDevolucion(state, payload) {
    state.observacionesDevolucion = payload
  },
  setFechaVigencia(state, payload) {
    state.fechaVigencia = payload
  },
  setMedioDeContacto(state, payload) {
    state.medio_de_contacto = payload
    agregarMedioContactoStorage(payload)
  },
  setAse(state, payload) {
    state.ase = payload
  },
  setLocation(state, payload) {
    state.location = payload
  },
  setSolStatus(state, payload) {
    state.estatus = payload
  },
  setReferencia(state, payload) {
    state.referencia = payload
  },
  setNumUsuarioApoyo(state, payload) {
    state.num_usuario_apoyo = payload
  },
}

const actions = {
  actualizarCredito(context, payload) {
    context.commit('setCredito', payload)
    // context.commit('setPlazos')
  },
  actualizarPlazos(context) {
    context.commit('setPlazos')
  },
  actualizarConfirmacion(context, payload) {
    context.commit('setConfirmacion', payload)
  },
  actualizarEditable(context, payload) {
    context.commit('setEditable', payload)
  },
  actualizarFinalizado(context, payload) {
    context.commit('setFinalizado', payload)
  },
  actualizaOtp(context, payload) {
    context.commit('setOtp', payload)
  },
  actualizaOtpFirma(context, payload) {
    context.commit('setOtpFirma', payload)
  },
  actualizarEntrada(context, payload) {
    console.log(payload)
    context.commit('setEntrada', payload)
    context.commit('persona/establecerBancaActiva', payload.banca_activa, {
      root: true,
    })
    context.commit('setConvenio', payload.id_convenio)
    context.commit('setSolStatus', {
      estatus: payload.id_status,
      substatus: payload.id_sub_status,
      banca_activa: payload.banca_activa,
    })
    // context.commit('',)
  },
  establecerStatusSol(context, payload) {
    context.commit('setSolStatus', {
      estatus: payload.id_status,
      substatus: payload.id_sub_status,
      banca_activa: payload.banca_activa,
    })
  },
  establecerPlazosInicio(context, payload) {
    context.commit('setPlazosDisponibles', payload)
  },
  establecerRangoMontosPlazos(context, payload) {
    context.commit('setRangoMontosPlazos', payload)
  },
  actuliazarMontoPago(context, payload) {
    context.commit('setMontoPago', payload)
    context.commit('setTotalLiquidacion', payload[0].total_liquidacion)
  },
  actualizarFolioDigital(context, payload) {
    context.commit('setFolioDigital', payload.folioDigital)
  },
  setEsOtpFirmaValido(context, payload) {
    context.commit('setEsOtpFirmaValido', payload)
  },
  setSonTerminosAceptados(context, payload) {
    context.commit('setSonTerminosAceptados', payload)
  },
  setAceptaFirmar(context, payload) {
    context.commit('setAceptaFirmar', payload)
  },
  setSonTerminosBuroAceptados(context, payload) {
    context.commit('setSonTerminosBuroAceptados', payload)
  },
  setSonTerminosBuroConfirmados(context, payload) {
    context.commit('setSonTerminosBuroConfirmados', payload)
  },
  setConvenio(context, payload) {
    context.commit('setConvenio', payload)
  },
  actualizaPlazo(context, payload) {
    context.commit('setPlazo', payload)
  },
  actualizaCatalagoPeriodicidad(context, payload) {
    context.commit('setCatalogoPeriodicidad', payload)
  },
  actualizaDatosFrecuenciaSeleccionada(context, payload) {
    const datosPeriodicidad = context.state.catalogoPeriodicidad.find(
      (periodicidad) => periodicidad.frecuencia === payload
    )
    context.commit(
      'setDatosPeriodicidadFrecuenciaSeleccionada',
      datosPeriodicidad
    )
  },
  setIdSolicitud(context, payload) {
    context.commit('setIdSolicitud', payload)
  },
  setAplicaDevolucion(context, payload) {
    context.commit('setAplicaDevolucion', payload)
  },
  setAplicaDevolucionMonto(context, payload) {
    context.commit('setAplicaDevolucionMonto', payload)
  },
  setAplicaDevolucionDomicilio(context, payload) {
    context.commit('setAplicaDevolucionDomicilio', payload)
  },
  setObservacionesDevolucion(context, payload) {
    context.commit('setObservacionesDevolucion', payload)
  },
  actualizaFechaVigencia(context, payload) {
    context.commit('setFechaVigencia', payload)
  },
  actualizarMedioContacto(context, payload) {
    context.commit('setMedioDeContacto', payload)
  },
  actualizarAse(context, payload) {
    context.commit('setAse', payload)
  },
  actualizarUbicacion(context, payload) {
    context.commit('setLocation', payload)
  },
  establecerReferencia(context, payload) {
    context.commit('setReferencia', payload)
  },
  establecerNumUsuarioApoyo(context, payload) {
    context.commit('setNumUsuarioApoyo', payload)
  },
}

const getters = {
  obtenerRangoMontosPlazos(state) {
    return state.rangoMontosPlazos
  },
  obtenerCredito(state) {
    return state.credito
  },
  obtenerFrecuencias(state) {
    return state.frecuencia
  },
  obtenerPlazos(state) {
    return state.plazos
  },
  obtenerConfirmacion(state) {
    return state.confirmado
  },
  obtenerEditable(state) {
    return state.editable
  },
  obtenerFinalizado(state) {
    return state.finalizado
  },
  obtenerOtpInicio(state) {
    return state.otpInicio
  },
  obtenerOtpFirma(state) {
    return state.otpFirma
  },
  obtenerFolioDigital(state) {
    return state.folioDigital
  },
  obtenerEsOtpFirmaValido(state) {
    return state.esOtpFirmaValido
  },
  obtenerSolicitudDigitalRequest(state, _, _2, rootGetters) {
    let datos = null
    if (state.aplicaDevolucionMonto) {
      datos = {
        folioDigital: state.folioDigital,
        idSubproducto: state.credito.tipoCredito,
        //0,
        idConvenio: state.idConvenio ? state.idConvenio : 0,
        //   datos.idSubproducto == ID_PRODUCTO_CREDITO_ACTIVACASH
        //     ? 0
        //:
        aceptoFirmar: 1, //state.sonTerminosAceptados,

        montoSolicitado: state.credito.monto.val,
        montoTotalPagar: state.total_liquidacion,
        montoTotalRecibo: state.credito.montoPago.val,
        cat: state.credito.montoPago.cat,
        //
        idPeriodicidad: 0, //state.credito.frecuenciaSeleccionada.id_periodicidad,
        id_esquema: 0, //state.credito.frecuenciaSeleccionada.id_esquema,
        plazo: state.credito.plazo.val,
        tasaMensual: 0, //state.credito.tasa.val,
        telefono: rootGetters['persona/obtenerTelefono'],
        Correo: ' ', //rootGetters['persona/obtenerCorreo'],
        Password: ' ', //rootGetters['persona/obtenerContrasena'],
        aceptoTerminos: true, //state.sonTerminosAceptados,
        acepto_consulta_buro: true, //state.sonTerminosAceptados,
        opt: state.otpFirma,
        numeroSocio:
          rootGetters['persona/obtenerPersona'].datosPersonales.numero,
      }
    } else {
      datos = {
        montoSolicitado: state.credito.monto.val,
        montoTotalPagar: state.total_liquidacion,
        montoTotalRecibo: state.credito.montoPago.val,
        cat: state.credito.montoPago.cat,
        idPeriodicidad: state.credito.frecuenciaSeleccionada.id_periodicidad,
        id_esquema: state.credito.frecuenciaSeleccionada.id_esquema,
        plazo: state.credito.plazo.val,
        tasaMensual: state.credito.tasa.val,
        telefono: rootGetters['persona/obtenerTelefono'],
        correo: rootGetters['persona/obtenerCorreo'],
        password: rootGetters['persona/obtenerContrasena'],
        aceptoTerminos: state.sonTerminosAceptados,
        folioDigital: state.folioDigital,
        idSubproducto: state.credito.tipoCredito,
        aceptoFirmar: state.sonTerminosAceptados,
        otp: state.otpFirma,
        numeroSocio:
          rootGetters['persona/obtenerPersona'].datosPersonales.numero,
        idConvenio: state.idConvenio ? state.idConvenio : 0,
        // datos.idSubproducto == ID_PRODUCTO_CREDITO_ACTIVACASH
        //   ? 0
        //   :
        // state.idConvenio,
        documentos: [],
        medio_de_contacto: state.medio_de_contacto
          ? state.medio_de_contacto
          : 0,
        calle: rootGetters['persona/obtenerDireccion']
          ? rootGetters['persona/obtenerDireccion'].calle
          : '',
        numero_exterior: rootGetters['persona/obtenerDireccion']
          ? rootGetters['persona/obtenerDireccion'].numExt
          : '',
        numero_interior: rootGetters['persona/obtenerDireccion']
          ? rootGetters['persona/obtenerDireccion'].numInt
          : '',
        id_colonia_cnbv:
          rootGetters['persona/obtenerDireccion'].selectedColonia,
        ubicacion_longitud: state.location.lon
          ? state.location.lon.toString()
          : '',
        ubicacion_latitud: state.location.lat
          ? state.location.lat.toString()
          : '',
        contacto_referencia_nombre: state.referencia
          ? state.referencia.nombre
          : null,
        contacto_referencia_telefono: state.referencia
          ? state.referencia.telefono.toString()
          : null,
        num_usuario_apoyo: state.ase ? state.ase : state.num_usuario_apoyo,
        coincide_doc_ine:
          rootGetters['persona/obtenerDomicilioCoincideIne'] === true,
      }
    }
    return datos
  },
  obtenerSonTerminosAceptados(state) {
    return state.sonTerminosAceptados
  },
  obtenerAceptaFirmar(state) {
    return state.aceptaFirmar
  },
  obtenerSonTerminosBuroAceptados(state) {
    return state.sonTerminosBuroAceptados
  },
  obtenerSonTerminosBuroConfirmados(state) {
    return state.sonTerminosBuroConfirmados
  },
  obtenerIdSolicitud(state) {
    return state.idSolicitud
  },
  obtenerAplicaDevolucion(state) {
    return state.aplicaDevolucion
  },
  obtenerAplicaDevolucionMonto(state) {
    return state.aplicaDevolucionMonto
  },
  obtenerAplicaDevolucionDomicilio(state) {
    return state.aplicaDevolucionDomicilio
  },
  obtenerObservacionesDevolucion(state) {
    return state.observacionesDevolucion
  },
  obtenerFechaVigencia(state) {
    const fechaVigencia = new Date(state.fechaVigencia).toLocaleDateString(
      'es-MX'
    )
    return fechaVigencia
  },
  obtenerMedioDeContacto(state) {
    return state.medio_de_contacto
  },
  obtenerAse(state) {
    return state.ase
  },
  obtenerUbicacion(state) {
    return state.location
  },
  obtenerEstatusSol(state) {
    return state.estatus
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
